import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IDeleteCampaignPayload {
    campaignId: string
    sagaCB?: {
        onSuccess: any
    }
}

export interface IState {
    status: string
    data: any
    errors: any
}

const initialState: IState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const deleteCampaign = createSlice({
    name: 'campaigns/delete-campaign',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IDeleteCampaignPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const deleteCampaignActions = deleteCampaign.actions
export default deleteCampaign.reducer
